import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject: BehaviorSubject<boolean>;
  public loading$: Observable<boolean>;

  constructor() {
    this.loadingSubject = new BehaviorSubject<boolean>(false);
    this.loading$ = this.loadingSubject.asObservable();
  }

  public set loading(content: boolean) {
    this.loadingSubject.next(content);
  }

  public get loading(): boolean {
    return this.loadingSubject.getValue();
  }
}
